import React from 'react'
import Link from 'next/link'
import useTrans from '../../../hooks/useTrans'

const ProdottoPersonalizzazioneCard = ({
  prodotto,
  colore,
  quantita,
  taglia,
  conLink,
  fromPdf,
}) => {
  const t = useTrans()

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div className="p__personalizzazione__card">
        <img
          className="p__personalizzazione__card__image"
          src={
            fromPdf
              ? prodotto?.thumb_image?.url || prodotto?.main_image?.url
              : !quantita
              ? prodotto?.immagini?.length > 0
                ? prodotto?.immagini[0]?.url
                : 'https://placehold.co/150x150/png'
              : prodotto?.main_image?.url
          }
        />
        <div className="p__personalizzazione__card__content">
          <div>
            {conLink && prodotto?.url ? (
              <Link legacyBehavior href={prodotto?.url}>
                <a target="_blank">
                  <strong className="p__personalizzazione__card__content__title">
                    {prodotto?.codice}
                  </strong>
                </a>
              </Link>
            ) : (
              <strong className="p__personalizzazione__card__content__title">
                {prodotto?.codice}
              </strong>
            )}
            <p>
              {' '}
              <span className="p__personalizzazione__card__content__placeholder">
                {t('COLORE')}:{' '}
              </span>
              {colore?.nome}
            </p>
            {taglia && (
              <p>
                <span className="p__personalizzazione__card__content__placeholder">
                  {t('TAGLIA')}:{' '}
                </span>
                {taglia}
              </p>
            )}
          </div>
          <div>
            <p>
              {t('Quantità')}: {quantita}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(ProdottoPersonalizzazioneCard)
